import {Action} from '@ngrx/store';

/**
 * All actions of the search sub-store are described here
 * An action can have an optional payload
 */

export const UPDATE_SEARCH_AGGREGATION = '[SEARCH] UPDATE_SEARCH_AGGREGATION';
export const UPDATED_SEARCH_AGGREGATION = '[SEARCH] UPDATED_SEARCH_AGGREGATION';
export const UPDATE_SEARCH_PARAMS = '[SEARCH] UPDATE_SEARCH_PARAMS';
export const DELETE_SEARCH_PARAMS = '[SEARCH] DELETE_SEARCH_PARAMS';
export const UPDATE_FINISHED_SEARCH_PARAMS = '[SEARCH] UPDATE_FINISHED_SEARCH_PARAMS';
export const DELETE_FINISHED_SEARCH_PARAMS = '[SEARCH] DELETE_FINISHED_SEARCH_PARAMS';

export class UpdateSearchAggregationAction implements Action {
  readonly type = UPDATE_SEARCH_AGGREGATION;
}

export class UpdatedSearchAggregationAction implements Action {
  readonly type = UPDATED_SEARCH_AGGREGATION;

  constructor(public payload: VehicleOfferSearchAggregation) {
  }
}

export class UpdateSearchParamsAction implements Action {
  readonly type = UPDATE_SEARCH_PARAMS;

  constructor(public payload: VehicleOfferSearchParams) {
  }
}

export class DeleteSearchParamsAction implements Action {
  readonly type = DELETE_SEARCH_PARAMS;
}

export class UpdateFinishedSearchParamsAction implements Action {
  readonly type = UPDATE_FINISHED_SEARCH_PARAMS;

  constructor(public payload: VehicleOfferSearchParams) {
  }
}

export class DeleteFinishedSearchParamsAction implements Action {
  readonly type = DELETE_FINISHED_SEARCH_PARAMS;
}

export type SearchAction = UpdateSearchAggregationAction
    | UpdatedSearchAggregationAction
    | UpdateSearchParamsAction
    | DeleteSearchParamsAction
    | UpdateFinishedSearchParamsAction
    | DeleteFinishedSearchParamsAction;
